<template>
  <div>
    <div
      @keydown.esc="closeResetPasswordPopup"
      ref="resetPasswordPopup"
      tabindex="0"
      class="lite-lp-popup lite-lp-popup-forgot-password-overlay"
      id="forgot-password-overlay"
    >
      <div class="lite-lp-popup-content lite-lp-forgot-password-popup">
        <header class="popup-header">
          <a
            class="lite-lp-popup-close"
            id="close-reset-password"
            @click="closeResetPasswordPopup"
          ></a>
          <h2 class="lite-lp-popup-title">
            {{ $t("RESET_PASS") }}
          </h2>
        </header>
        <section class="popup-main-content">
          <div class="reset-password-form">
            <div v-if="message" class="lite-lp-popup-success">
              <img src="@/assets/images/check.svg" alt="icon" class="icon" />
               <p class="text">{{ $t("RESET_EMAIL_SENT") }}</p>
               <p>{{ $t("DO_NOT_SEE_CHECK_SPAM") }}</p>
            </div>

            <form
              v-if="!message"
              class="lite-lp-forgot-password-popup-form"
              id="resetPasswordForm"
              autocomplete="off"
              @submit="resetPass($event)"
            >
              <div class="input-wrap" :class="{ error: $v.userName.$error }">
                <div class="input-design">
                  <input
                    type="text"
                    :placeholder="$t('NAME')"
                    class="lite-lp-popup-input"
                    v-model="userName"
                    @input="cleanIsErrorInDetails(), $v.userName.$touch()"
                  />
                </div>
                <span class="error-text">
                  {{ $t("USERNAME_MISSING") }}
                </span>
              </div>
              <div class="input-wrap" :class="{ error: $v.email.$error }">
                <div class="input-design">
                  <input
                    type="text"
                    :placeholder="$t('EMAIL')"
                    class="lite-lp-popup-input"
                    v-model="email"
                    @input="cleanIsErrorInDetails(), $v.email.$touch()"
                  />
                </div>
                <span class="error-text" v-if="!$v.email.required">
                  {{ $t("EMAIL_MISSING") }}
                </span>
                <span
                  class="error-text"
                  v-if="$v.email.required && !$v.email.email"
                >
                  {{ $t("EMAIL_INVALID") }}
                </span>
              </div>
              <div v-if="isErrorInDetails" class="error-msg">
                {{ $t("ERROR_AT_DETAILS") }}
              </div>
              <button
                type="submit"
                id="submitButton"
                class="lite-lp-popup-submit"
                :disabled="
                  !$v.userName.required || !$v.email.required || !$v.email.email
                "
              >
                {{ $t("SEND") }}
              </button>
            </form>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import config from '@/config.js'

export default {
  name: 'password-reset-popup',

  data: function () {
    return {
      isErrorInDetails: false,
      userName: null,
      email: null,
      librarySlug: this.$route.params.librarySlug,
      message: null
    }
  },
  validations: {
    userName: {
      required
    },
    email: {
      required,
      email
    }
  },

  methods: {
    cleanIsErrorInDetails () {
      if (this.isErrorInDetails) { this.isErrorInDetails = false }
    },
    closeResetPasswordPopup () {
      this.$router.push({ name: 'logIn' })
    },
    resetPass (e) {
      e.preventDefault()
      const url = config.libraryUrl + this.librarySlug + '/home-page/set-new-password/'
      this.$store.dispatch('checkEmailAndUsername', { username: this.userName, email: this.email, url: url }
      // calls function in store to send new password to user, if users data is good sends back true. else sends back false. currently gets true
      ).then((response) => {
        // if reset password success
        this.message = this.$t('NEW_PASS_IN_EMAIL')
        setTimeout(() => {
        // timeout added so user can see message that new password was sent to users Email
          this.$router.push({ name: 'homePage' })
        }, 5000)
      }).catch(() => {
        this.isErrorInDetails = true
      })
    }
  }
}

</script>
<style lang="scss" scoped>
.lite-lp-popup-content .error-text {
  display: none;
  margin-top: 8px;
  font-size: 12px;
  color: #FF0000;
}
.lite-lp-popup-content .input-wrap.error .input-design {
  border: 2px solid #FF0000;
}
.lite-lp-popup-content .input-wrap.error .error-text {
  display: block;
}
.lite-lp-popup-content .security-code-wrap.error .error-text {
  display: block;
}
.lite-lp-login-popup-forgot-password{
      display: block; width: 100%; text-align: start; font-size: 16px; padding-top: 17px; margin-bottom: 7px;
       cursor: pointer;
      .rtl &{direction: rtl;}
      .ltr &{direction: ltr;}
      &:hover{color: #2196F3; text-decoration: underline;}
    }
        .lite-lp-popup-close {
  position: absolute;
  width: 32px;
  height: 32px;
  transition: transform 0.35s ease-in-out;
  cursor: pointer;
}
.lite-lp-popup-close:hover, .lite-lp-popup-close:focus {
  transform: rotate(180deg);
  background-color: transparent;
}
.lite-lp-popup-close:before, .lite-lp-popup-close:after {
  content: "";
  position: absolute;
  display: block;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transform-origin: center;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 5px;
}
.lite-lp-popup-close:before {
  transform: rotate(45deg);
}
.lite-lp-popup-close:after {
  transform: rotate(-45deg);
}
</style>
